<div *ngIf="this.loading" class="cssload-container">
    <div class="cssload-speeding-wheel"></div>
    <div class="progress-bar-container" *ngIf="this.progress !== undefined && this.progress !== null">
        <div class="progress-bar" [style.width.%]="this.progress"></div>
    </div>
</div>